// extracted by mini-css-extract-plugin
var _1 = "EditStep_content__YIWEB";
var _2 = "EditStep_form__3jlNI";
var _3 = "EditStep_scrollbarOffset__G2Zmd";
export { _1 as "content", _2 as "form", _3 as "scrollbarOffset" }
